import type { ComponentProps, ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';

import { BackButton } from '../BackButton';
import type {
  AuthFormType,
  AuthLayoutCSS,
  AuthLayoutCSSItem,
} from '../../types';
import { CloseButton } from '../CloseButton';

type Props = {
  children: ReactNode;
  onBack?(): void;
  onClose?(): void;
  isShownCloseIcon?: boolean;
  isShownBackIcon?: boolean;
} & AuthLayoutCSSItem;

const Wrapper = styled.div<Pick<AuthLayoutCSSItem, 'wrapperCSS' | 'isMobile'>>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${({ isMobile }) => (isMobile ? '100%' : '290px')};
  ${(props) => props.wrapperCSS}
`;
const Container = styled.div<Pick<AuthLayoutCSSItem, 'containerCSS'>>`
  position: relative;
  width: 100%;
  ${(props) => props.containerCSS}
`;

export const AuthLayout = ({
  children,
  onBack,
  isMobile,
  onClose,
  wrapperCSS,
  containerCSS,
  isShownCloseIcon,
  isShownBackIcon,
}: Props) => (
  <Wrapper isMobile={isMobile} wrapperCSS={wrapperCSS}>
    <Container containerCSS={containerCSS}>{children}</Container>
    {isShownBackIcon && onBack && <BackButton onClick={onBack} />}
    {isShownCloseIcon && onClose && <CloseButton onClick={onClose} />}
  </Wrapper>
);

export const getAuthLayoutWithCSS =
  (authLayoutCSS?: AuthLayoutCSS) =>
  (
    type: AuthFormType,
    isShownCloseIcon?: boolean,
    isShownBackIcon?: boolean,
    isMobile?: boolean,
  ) => {
    const Component = (props: ComponentProps<typeof AuthLayout>) => (
      <AuthLayout
        isMobile={isMobile}
        isShownCloseIcon={isShownCloseIcon}
        isShownBackIcon={isShownBackIcon}
        {...props}
        {...(authLayoutCSS && authLayoutCSS[type])}
      />
    );
    Component.displayName = 'AuthLayoutWithCSS';

    return Component;
  };
